import * as promoDetailApi from '../../api/promo-detail-api';
import { IResult } from '../../models/result-models';
import { IPromoDetail } from '../../models/talend';
import {
    apiCallError,
    beginApiCall,
    endApiCall,
} from '../api/api-status-action';

export const LOAD_PROMODETAILS_SUCCESS = 'LOAD_PROMODETAILS_SUCCESS';
export const LOAD_PROMODETAILS_ERROR = 'LOAD_PROMODETAILS_ERROR';

export const RELEASE_PROMODETAILS_SUCCESS = 'RELEASE_PROMODETAILS_SUCCESS';
export const RELEASE_PROMODETAILS_ERROR = 'RELEASE_PROMODETAILS_ERROR';

// Actions
export const loadPromoDetailSuccess = (result: IResult<IPromoDetail[]>) => ({
    type: LOAD_PROMODETAILS_SUCCESS,
    result,
});

export const loadPromoDetailsError = (error: any) => ({
    type: LOAD_PROMODETAILS_ERROR,
    result: error,
});

export const releasePromoDetailsSuccess = (result: number) => ({
    type: RELEASE_PROMODETAILS_SUCCESS,
    result,
});

export const releasePromoDetailsError = (error: any) => ({
    type: RELEASE_PROMODETAILS_ERROR,
    result: error,
});

// Thunks
export const loadPromoDetails = (billTo: string, shipTo: string) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await promoDetailApi.getAll(billTo, shipTo);
            dispatch(loadPromoDetailSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const releasePromo = (
    billTo: string,
    shipTo: string,
    orderNumber: number
) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            await promoDetailApi.release(orderNumber);
            dispatch(loadPromoDetails(billTo, shipTo));
            dispatch(endApiCall());
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};
